import { render, staticRenderFns } from "./configGroup.vue?vue&type=template&id=e60fc5d2&scoped=true&"
import script from "./configGroup.vue?vue&type=script&lang=js&"
export * from "./configGroup.vue?vue&type=script&lang=js&"
import style1 from "./configGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60fc5d2",
  null
  
)

export default component.exports